/* eslint-disable */
import notify from './notify'
import date from './date'
import host from './host'
import math from './math'
import state from './state'
import form from './form'
import EventSystem from './EventSystem'
import assets from './assets'
import logger from './logger'
import translate from './translate'

var helpers = {}
try {
  helpers = require('../projects/' + process.env.REACT_APP_PROJECT + '/helpers')
} catch (e) {
  logger.debug('No project-specific helpers')
}
module.exports = {
  notify,
  date,
  host,
  math,
  logger,
  Translate: translate,
  AssetsHelper: assets,
  StateHelper: state,
  FormHelper: form,
  EventSystem: EventSystem,
  ...helpers
}



// WEBPACK FOOTER //
// ./src/helpers/index.js